<template>
  <div id="left_nav">
    <ul class="left_nav_list">
      <li class="no_arrow">
          <div class="left_f_list no_arrow" :class="{'active': $route.name === 'dashboard'}">
              <router-link to="/">
                  <span class="left_img">
                    <img src="@/assets/media/images/left-icon/left-ic-1.png" alt="">
                  </span>
                  <span>Dashboard</span> 
              </router-link>
          </div>
      </li>
<!--      <li v-if="can('ticket-manage')" class="no_arrow">
          <div class="left_f_list no_arrow" :class="{'active': $route.name === 'tickets'}">
              <router-link :to="{name: 'tickets'}">
                  <span class="left_img">
                    <img src="@/assets/media/images/left-icon/ticket.png" alt="">
                  </span>
                  <span>Tickets</span>
              </router-link>
          </div>
      </li>-->

      <li v-if="can('ticket-manage')"
          @mouseleave="handleMouseLeave"
      >
        <div @mouseenter="handleMouseEnter" @click="navSwitch($event , '.left_nav_list > li', '.left_f_list', '.left_nav_level2', '.left_f_list_level2')" data-toggle="accordion" data-target="#ticketManage" class="left_f_list"
             :class="{'open': ticketManageMenu.includes($route.name) && !isMenuCollapse}"
        >
          <span class="left_img">
            <span class="left_img"><img src="@/assets/media/images/left-icon/left-ic-7.png" alt=""></span>
          </span>
          <span>Tickets</span>
        </div>
        <ul class="sub_accordion first_level"
            :class="{'open current': ticketManageMenu.includes($route.name) && !isMenuCollapse}" id="ticketManage"
        >
          <li :class="{'active_sub_menu': $route.name === 'new_tickets'}">
            <router-link :to="{name: 'new_tickets'}">신규 티켓</router-link>
          </li>
          <li :class="{'active_sub_menu': $route.name === 'resolved_tickets'}">
            <router-link :to="{name: 'resolved_tickets'}">완료 티켓</router-link>
          </li>
<!--          <li :class="{'active_sub_menu': $route.name === 'tickets'}">
            <router-link :to="{name: 'tickets'}">All Ticket</router-link>
          </li>-->
        </ul>
      </li>

      <li v-if="can('support-request-manage') || can('company-manage') || can('group-manage') || can('roles-manage') || can('agent-manage') || can('roles-manage') ||  can('contact-manage') || can('chat-setting-manage')"
          @mouseleave="handleMouseLeave"
      >
        <div @mouseenter="handleMouseEnter" @click="navSwitch($event , '.left_nav_list > li', '.left_f_list', '.left_nav_level2', '.left_f_list_level2')" data-toggle="accordion" data-target="#Ticket" class="left_f_list" :class="{'open': ticketMenu.includes($route.name) && !isMenuCollapse}">
          <span class="left_img">
            <span class="left_img"><img src="@/assets/media/images/left-icon/left-ic-7.png" alt=""></span>
          </span>
          <span>Settings</span>
        </div>
        <ul class="sub_accordion first_level" :class="{'open current': ticketSettingsMenu.includes($route.name) && !isMenuCollapse}" id="Ticket">
          <li v-if="can('agent-manage')" :class="{'active_sub_menu': $route.name === 'users'}">
            <router-link :to="{name: 'users'}">Employees</router-link>
          </li>
          <li v-if="can('ticket-category-manage')" :class="{'active_sub_menu': $route.name === 'ticket_category'}">
            <router-link :to="{name: 'ticket_category'}">Ticket Category</router-link>
          </li>
          <li v-if="can('roles-manage')" :class="{'active_sub_menu': $route.name === 'roles'}">
            <router-link :to="{name: 'roles'}">Roles</router-link>
          </li>
          <li v-if="can('customer-manage')" :class="{'active_sub_menu': $route.name === 'customers'}">
            <router-link :to="{name: 'customers'}">Customer</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { TOKEN } from '@/util/AppAbility';
import { useAbility } from '@casl/vue'
import { mapGetters } from "vuex";
import helperMixins from '@/mixins/helperMixins';

export default {
  mixins: [helperMixins],
  inject: {
    ability: { from: TOKEN }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      ticketMenu: ['tickets', 'create-ticket', 'update-ticket', 'view-ticket', 'create-email', 'support-requests', 'create-support-request', 
                  'chat', 'update-support-request', 'view-support-request', 'users', 'create-user', 'update-user', 'companies', 'create-company', 
                  'update-company', 'view-company','contacts', 'create-contact', 'update-contact', 'view-contact', 'chat_categories', 'chat_settings', 
                  'groups', 'create-group','update-group', 'view-group','support_request_types', 'create_support_request_type', 'update_support_request_type', 
                  'view_support_request_type', 'roles'
                ],
      ticketSettingsMenu: ['create-email', 'support-requests', 'create-support-request', 'update-support-request', 'view-support-request', 'users',
                   'create-user', 'update-user', 'companies', 'create-company',
                  'update-company', 'view-company','contacts', 'create-contact', 'update-contact', 'view-contact',
                  'groups', 'create-group','update-group', 'view-group','support_request_types', 'create_support_request_type', 'update_support_request_type',
                  'view_support_request_type', 'roles'
                ],
      ticketManageMenu: ['tickets', 'new_tickets', 'resolved_tickets', 'view-ticket'],
    }
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isMenuCollapse: "settings/isMenuCollapse",
    })
  },
  mounted(){

  },
  methods: {
    handleMouseEnter() {
      if (window.$(".left_menu_collapse").length > 0) {
        this.showHideNav(event, '.left_nav_list > li', '[data-toggle="accordion"]', '.left_f_list');
      }
    },
    handleMouseLeave() {
      if (window.$(".left_menu_collapse").length > 0) {
        this.hideOtherNav('.left_nav_list > li', '.left_f_list');
        this.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
        this.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
      }
    },
    reload(name) {
      if (this.$route.name === name) {
        this.$store.commit('setReload', true)
      }
    },
  }
}
</script>
<style scoped>
.active_sub_menu {
  color: #000000;
  font-weight: 600;
}

.router-link-exact-active {
  color: #000000;
  font-weight: 600;
}

.d_block {
  display: block;
}

.left_nav_level2 .active {
  background: rgba(113, 113, 113, 0.3);
}

.active__sub_sub_menu a{
  color: #000000;
  font-weight: 600;
}
</style>